import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerOrders, OrderCheckout, OrderDetails, Orders } from 'src/app/_models/Orders';
import { ToastService } from 'src/app/_services/toastservice';
import { Location } from 'src/app/_models/Location';
import { OrdersService } from 'src/app/_services/orders.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-orderdetails',
  templateUrl: './orderdetails.component.html',
  styleUrls: ['./orderdetails.component.css'],
  providers: []
})

export class OrderdetailsComponent implements OnInit {
  // public order: Orders[] = [];
  public order = new Orders();
  private selectedBrand;
  Locations: Location[] = [];
  selectedLocations = [];
  locationID = 0;
  StatusMsg = "";
  public orderDetails = new OrderDetails();
  public orderOrderCheckout = new OrderCheckout();
  public orderCustomerInfo = new CustomerOrders();
  // public orderDetails: OrderDetails[] = [];
  // public orderOrderCheckout: OrderCheckout[] = [];
  // public orderCustomerInfo: CustomerOrders[] = [];

  locationSubscription: Subscription;
  constructor(public service: OrdersService,
    public ls: LocalStorageService,
    public ts: ToastService,
    public router: Router,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService) {

    this.selectedBrand = this.ls.getSelectedUser().brandID;

  }

  ngOnInit() {
    this.setSelectedOrder();

  }

  setSelectedOrder() {
    
    this.route.paramMap.subscribe(param => {
      const sid = +param.get('id');
      if (sid) {
        this.service.getById(sid).subscribe(res => {
          //Set Forms

          this.editForm(res);
        });
      }
    })
  }

  /**
   * Allowed status transitions per current status.
   * Terminal states (100 Delivered, 106 Cancelled) have no outgoing moves.
   */
  private readonly allowedTransitions: { [key: number]: number[] } = {
    101: [102, 100, 104, 105, 106],  // In Process
    102: [100, 104, 105, 106],        // Accepted
    103: [100, 104, 105, 106],        // Pending Payment
    100: [],                          // Delivered → terminal
    104: [106],                       // Payment Failed → can cancel
    105: [100, 106],                  // Delivery Failed → retry or cancel
    106: []                           // Cancelled → terminal
  };

  canTransitionTo(targetStatus: number): boolean {
    const current = this.order?.statusID ?? 0;
    const allowed = this.allowedTransitions[current] ?? [];
    return allowed.indexOf(targetStatus) !== -1;
  }

  updateOrder(order, status) {
    // Block invalid transitions early — no API call if it isn't allowed
    if (!this.canTransitionTo(status)) {
      this.ts.showError("Error", "This status change is not allowed for the current order state.");
      return;
    }

    this.ngxService.start();
    // if (this.StatusMsg == '' || this.StatusMsg == undefined || this.StatusMsg == null) {
    //   this.ts.showError("Error", "Kindly add the email message, while updating the status of order");
    // }!
    // else {
    order.statusID = status;
    order.StatusMsg = this.StatusMsg;
    //Update customer
    this.service.update(order).subscribe(data => {

      if (data == 1) {
        this.ts.showSuccess("Success", "Record updated successfully.")
        this.router.navigate(['/admin/orders']);
      }
      else{
        this.ts.showError("Error", "Failed to update record.")  
      }
      this.ngxService.stop();
    }, error => {
      this.ts.showError("Error", "Failed to update record.")
      this.ngxService.stop();
    });
    // }
  }
  private editForm(obj) {
debugger;
    this.order = obj.order;
    this.orderDetails = obj.orderDetails;
    this.orderCustomerInfo = obj.customerOrders;
    // this.orderOrderCheckout = obj.orderCheckouts;
  }
}